module.exports = __webpack_public_path__ + "static/media/TS-asset2.20b64c05.svg";